import { get } from 'lodash'

const isCyjPosProduct = (product) => {
  return get(product, 'externalProductSourceType') === 'cyjPos' ||
    get(product, 'MemberStoreProduct.externalProductSourceType') === 'cyjPos' ||
    get(product, 'externalExecutionResult.raw.cyjPos') != null
}

/**
 * 取得尚未在 CYJ POS 建立銷售單的商品
 * @param {Array} products - 會員商城訂單商品
 * @returns {Array} 尚未建立 CYJ POS 銷售單的商品
 */
export const getCyjPosPendingProducts = (products = []) => {
  return products.filter((product) => {
    const posSaleNo = get(product, 'externalExecutionResult.raw.cyjPos.posSaleNo')
    return isCyjPosProduct(product) && !posSaleNo
  })
}

/**
 * 判斷訂單是否已在 CYJ POS 建立銷售單
 * @param {Array} products - 會員商城訂單商品
 * @returns {boolean} 是否已建立 CYJ POS 銷售單
 */
export const isCyjPosOrderCreated = (products = []) => {
  const cyjPosProducts = products.filter(isCyjPosProduct)
  return cyjPosProducts.length > 0 && getCyjPosPendingProducts(products).length === 0
}
